import { render } from "./AccountsListView.vue?vue&type=template&id=6872016b&scoped=true"
import script from "./AccountsListView.vue?vue&type=script&lang=js"
export * from "./AccountsListView.vue?vue&type=script&lang=js"

import "./AccountsListView.vue?vue&type=style&index=0&id=6872016b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6872016b"]])

export default __exports__